import { Link } from "react-router-dom";
import { AuthContext } from "../util/api";
import { useContext } from "react";

export default function Chatmessagebox({ msg, backcolor, textcolor }) {

    const {  User } = useContext(AuthContext);   

    return <>
        <div

            style={{
                backgroundColor: backcolor
                ,
                color: textcolor,
                padding: "10px 14px",
                borderRadius: "15px",
                maxWidth: "70%",
            }}




        >
            <div>
                {msg.attachment_type === "video_call" ? <>

                    <Link style={{ paddingLeft: "20px", paddingRight: "20px" }}
                        className="btn btn-sm btn-primary" to={msg.message}>Join Vidoe Call</Link>


                </> : <> {msg.message_type === "text" ? <>   {msg.message || msg.text} </> :
                

                
                <>  
                {    msg.appointment?.patient_id  !==  User.id ?
                
                <div
                    dangerouslySetInnerHTML={{
                        __html: msg.lawyer_message || "",
                    }}
                />  : 

                <div
                    dangerouslySetInnerHTML={{
                        __html: msg.message || msg.text || "",
                    }}
                /> 
                }
                
                  </>

                
                
                
                }</>}




                {msg.admin === "yes" &&
                    <>
                        <br />
                        <span style={{ fontWeight: "bolder", color: "purple" }}  >From Admin</span>


                    </>

                }

            </div>

            {msg.attachment && (
                <div style={{ marginTop: "10px" }}>
                    {msg.attachment_type?.startsWith("image/") && (
                        <img
                            src={msg.attachment}
                            alt="attachment"
                            style={{ width: "100%", borderRadius: "10px" }}
                        />
                    )}
                    {msg.attachment_type?.startsWith("video/") && (
                        <video
                            controls
                            src={msg.attachment}
                            style={{ width: "100%", borderRadius: "10px" }}
                        />
                    )}
                    {!msg.attachment_type?.startsWith("image/") &&
                        !msg.attachment_type?.startsWith("video/") && (
                            <a
                                href={msg.attachment}
                                target="_blank"
                                rel="noreferrer"
                            >
                                📄 View Document
                            </a>
                        )}
                </div>
            )}
        </div>


    </>
}